import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
// import { Link } from 'react-router-dom';

const Experience = () => {
    return (
        <Container id="experience">
            <Row>
                <Col sm={12} md={4}>
                    <h3>Experience</h3>
                    <p>I am inspired by creating great work with people who are as passionate as I am about building something awesome.</p>
                </Col>
                <Col sm={12} md={8}>
                    <div className="row g-3">
                        <div className="card  p-3 col-md-12" >
                            <div className="d-flex justify-content-between">
                                <h4>Web Desinger</h4> <p>  <i><strong>ABEDIN IT LIMITED</strong></i></p>
                            </div>


                            <p>Web Designers are primarily responsible for creating webpages for companies or individuals. They must possess the technical know-how to convert material, such as images and written content, into proper format. They should have full knowledge of various graphic design software and programming codes and languages.</p>
                        </div>
                        <div className="card  p-3 col-md-12">
                            <div className="d-flex justify-content-between">
                                <h4>Web Desinger</h4> <p>  <i>

                                    <a
                                        class='social-icon-link github'
                                        href="https://www.fiverr.com/web_developer_3"
                                        target='_blank'
                                        aria-label='Github'
                                    >
                                        fiverr.com

                                    </a></i></p>
                            </div>
                            <h4>web Desinger on online market place</h4>
                            <p>HTML, CSS, LESS, SASS, Bootstrap, Wordpress, Ionic, Foundation, React.js.</p>
                        </div>


                    </div>

                </Col>
            </Row>
        </Container>
    );
}

export default Experience;
